import { LoadingSpinner } from "@/core/components/LoadingSpinner";
import { Skeleton } from '@/core/components/ui/skeleton';

interface DashboardLoaderProps {
  title?: string;
  description?: string;
  showSkeleton?: boolean;
}

export function DashboardLoader({ 
  title = "Loading Dashboard",
  description = "Fetching operators and initializing site management...",
  showSkeleton = true
}: DashboardLoaderProps) {
  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header skeleton */}
      <div className="mb-6">
        <div className="flex items-center gap-2 text-sm text-gray-600 mb-4">
          <Skeleton className="h-4 w-48 bg-gray-200" />
        </div>
        
        <div className="border-l-4 border-yellow-400 pl-4 mb-6">
          <Skeleton className="h-6 w-48 bg-gray-300" />
        </div>
      </div>

      {/* Loading content */}
      <div className="flex items-center justify-center py-16">
        <div className="text-center">
          <LoadingSpinner size="xl" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2 mt-4">{title}</h2>
          <p className="text-gray-600">{description}</p>
        </div>
      </div>
      
      {showSkeleton && (
        <div className="space-y-4">
          {/* Controls skeleton */}
          <div className="bg-white rounded-lg p-4 shadow-sm border">
            <div className="flex gap-4 mb-4">
              <Skeleton className="h-10 w-48 bg-gray-200" />
              <Skeleton className="h-10 w-48 bg-gray-200" />
            </div>
            <div className="flex gap-2">
              <Skeleton className="h-8 w-24 bg-gray-200" />
              <Skeleton className="h-8 w-24 bg-gray-200" />
            </div>
          </div>
          
          {/* Table skeleton */}
          <div className="bg-white rounded-lg border">
            <div className="grid grid-cols-12 gap-4 p-4 bg-gray-100 border-b">
              <Skeleton className="col-span-4 h-4 bg-gray-300" />
              <Skeleton className="col-span-2 h-4 bg-gray-300" />
              <Skeleton className="col-span-2 h-4 bg-gray-300" />
              <Skeleton className="col-span-2 h-4 bg-gray-300" />
              <Skeleton className="col-span-2 h-4 bg-gray-300" />
            </div>
            <div className="p-4 space-y-2">
              <Skeleton className="h-12 w-full bg-gray-200" />
              <Skeleton className="h-12 w-full bg-gray-200" />
              <Skeleton className="h-12 w-full bg-gray-200" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 